import React from 'react';
import '../../App.css'

const LeftArrow = (props) => {
  return (
    <div className="backArrow arrow" onClick={props.prevSlide}>
      {/* <i className="fa fa-arrow-left fa-2x" aria-hidden="true"></i> */}
      <i className="arrow-left"></i>
    </div>
  );
}


export default LeftArrow;